import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { Paper, Grid, Skeleton, Box, Typography, Stack } from "@mui/material";
import { getViewInstance } from "../actions/viewinstance";
import Header from "./layouts/Header";
import Footer from "./layouts/Footer";
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"
import ParticipantControl from "./partials/admincenter/ParticipantControl";
import ParticipantTable from "./partials/admincenter/ParticipantTable";
import { fetchParticipants } from "../reducers/admincenter_participants";
import AdminTabs from "./partials/admincenter/AdminTabs";
import { fetchCountrys } from "../reducers/reference_country";
import { fetchEducations } from "../reducers/reference_education";
import { fetchSpokenLanguages } from "../reducers/reference_spokenlanguage";
import { fetchPhoneTypes } from "../reducers/reference_phonetype";
import { fetchAddressTypes } from "../reducers/reference_addresstypes";
import { fetchMiscTypes } from "../reducers/reference_misctypes";
import { fetchRaces } from "../reducers/reference_race";
import { fetchBirthSexs } from "../reducers/reference_birthsex";
import { fetchGroups } from "../reducers/admincenter_groups";
import { Help, MoreVert } from "@mui/icons-material";


const AdminCenterParticipants = () => {

    const { mainUser: currentUser, status: authStatus } = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const [callVI, setCallVI] = useState(false)
    const { viewInstance, settings } = useSelector(state => state.viewinstance)
    const adminparticipantsStatus = useSelector(state => state.adminparticipants.status)
    const countryStatus = useSelector(state => state.countrys.status)
    const educationStatus = useSelector(state => state.educations.status)
    const languageStatus = useSelector(state => state.spokenlanguages.status)
    const phonetypeStatus = useSelector(state => state.phonetypes.status)
    const addresstypeStatus = useSelector(state => state.addresstypes.status)
    const misctypeStatus = useSelector(state => state.misctypes.status)
    const admingroupsStatus = useSelector(state => state.admingroups.status)
    const birthSexStatus = useSelector(state => state.birthsexs.status)
    const raceStatus = useSelector(state => state.races.status)
    const userIsAdmin = (currentUser && (currentUser.IsAdmin === true))

    useEffect(() => {

        if (userIsAdmin === false) {
            navigate('/home')
            //} else {
            //if (adminparticipantsStatus === 'idle') {
            //dispatch(fetchParticipants({ authToken: currentUser.AuthToken, page:0 }))
            //}
            //if (!callVI && (!viewInstance || !viewInstance.AdminCenterPage) && currentUser && currentUser.AuthToken && authStatus === 'success') {
            //setCallVI(true);
            //dispatch(getViewInstance('F68B82A2-D122-4A05-B11D-BD91A2A52DC3', currentUser.AuthToken))
            //}
        }

    }, [userIsAdmin, navigate])

    useEffect(() => {
        if ((userIsAdmin === true) &&
            currentUser &&
            (adminparticipantsStatus === 'idle')) {
            dispatch(fetchParticipants({ authToken: currentUser.AuthToken, page: 0 }))
        }
    }, [userIsAdmin, adminparticipantsStatus, currentUser, dispatch])

    useEffect(() => {
        if ((userIsAdmin === true) &&
            currentUser &&
            !callVI &&
            (!viewInstance || !viewInstance.AdminCenterPage) &&
            authStatus === 'success') {
            setCallVI(true);
            dispatch(getViewInstance('F68B82A2-D122-4A05-B11D-BD91A2A52DC3', currentUser.AuthToken))
        }
    }, [userIsAdmin, setCallVI, viewInstance, location.pathname, currentUser, authStatus])

    useEffect(() => {
        if (birthSexStatus === 'idle') {
            dispatch(fetchBirthSexs({ authToken: currentUser.AuthToken }))
        }
    }, [birthSexStatus, dispatch])

    useEffect(() => {
        if (raceStatus === 'idle') {
            dispatch(fetchRaces({ authToken: currentUser.AuthToken }))
        }
    }, [raceStatus, dispatch])

    useEffect(() => {
        if (countryStatus === 'idle') {
            dispatch(fetchCountrys({ authToken: currentUser.AuthToken }))
        }
    }, [countryStatus, dispatch])

    useEffect(() => {
        if (educationStatus === 'idle') {
            dispatch(fetchEducations({ authToken: currentUser.AuthToken }))
        }
    }, [educationStatus, dispatch])

    useEffect(() => {
        if (languageStatus === 'idle') {
            dispatch(fetchSpokenLanguages({ authToken: currentUser.AuthToken }))
        }
    }, [languageStatus, dispatch])

    useEffect(() => {
        if (phonetypeStatus === 'idle') {
            dispatch(fetchPhoneTypes({ authToken: currentUser.AuthToken }))
        }
    }, [phonetypeStatus, dispatch])

    useEffect(() => {
        if (addresstypeStatus === 'idle') {
            dispatch(fetchAddressTypes({ authToken: currentUser.AuthToken }))
        }
    }, [addresstypeStatus, dispatch])

    useEffect(() => {
        if (misctypeStatus === 'idle') {
            dispatch(fetchMiscTypes({ authToken: currentUser.AuthToken }))
        }
    }, [misctypeStatus, dispatch])

    useEffect(() => {
        if (admingroupsStatus === 'idle') {
            dispatch(fetchGroups({ authToken: currentUser.AuthToken }))
        }
    }, [admingroupsStatus, dispatch])

    const EditStatusArray = [
        countryStatus === 'success' ? true : false
        , educationStatus === 'success' ? true : false
        , languageStatus === 'success' ? true : false
        , phonetypeStatus === 'success' ? true : false
        , addresstypeStatus === 'success' ? true : false
        , misctypeStatus === 'success' ? true : false
        , birthSexStatus === 'success' ? true : false
        , raceStatus === 'success' ? true : false
        , admingroupsStatus === 'success' ? true : false
        , adminparticipantsStatus === 'success' ? true : false
    ]

    const motionVariants = {
        hidden: { opacity: 0, x: 0, y: 0 },
        show: {
            opacity: 1, x: 0, y: 0,
            transition: {
                delay: 0.1,
                duration: 0.5,
            }
        }
    }

    return (
        <div>
            <Header />
            {viewInstance && viewInstance.AdminCenterPage ? (
                <Grid container direction="row" spacing={2}>
                    <Grid item xs={12}>
                        <motion.div variants={motionVariants} initial="hidden" whileInView="show" style={{ height: '100%' }}>
                            <Paper elevation={1} style={{ marginTop: '150px', padding: '40px' }}>
                                <AdminTabs page="PARTICIPANTS" />
                            </Paper>
                        </motion.div>
                    </Grid>
                    <Grid item xs={12}>
                        <motion.div variants={motionVariants} initial="hidden" whileInView="show" style={{ height: '100%' }}>
                            <Paper elevation={1} style={{ padding: '40px' }}>
                                {
                                    EditStatusArray.indexOf(false) < 0
                                        ?
                                        <ParticipantControl ParticipantTab={viewInstance.AdminCenterPage.ParticipantTab} />
                                        : (<Skeleton variant="rectangular" animation="wave" sx={{ paddingTop: "20%" }} height={0} />)

                                }
                            </Paper>
                        </motion.div>
                    </Grid>
                    <Grid item xs={12}>
                        <motion.div variants={motionVariants} initial="hidden" whileInView="show" style={{ height: '100%' }}>
                            <Paper elevation={1} sx={{ py: '10px', px: '40px' }}>
                                {
                                    EditStatusArray.indexOf(false) < 0
                                        ? (
                                            <Stack direction={"row"} justifyContent={"center"} alignItems="center">

                                                <Help fontSize="small" />
                                                <Typography variant="caption" align="center" fontStyle="italic" >
                                                    You can sort and filter columns in the table below using the vertical elipses {"("}<MoreVert fontSize="small" />{")"}; double click a record for more options.
                                                </Typography>
                                            </Stack>
                                        )
                                        : (<Skeleton variant="rectangular" animation="wave" sx={{ paddingTop: "40%" }} height={0} />)
                                }
                            </Paper>
                        </motion.div>
                    </Grid>
                    <Grid item xs={12}>
                        <motion.div variants={motionVariants} initial="hidden" whileInView="show" style={{ height: '100%' }}>
                            <Paper elevation={1} style={{ padding: '20px' }}>
                                {
                                    EditStatusArray.indexOf(false) < 0
                                        ? (<ParticipantTable TableLocation="PARTICIPANT MANAGEMENT" ParticipantTab={viewInstance.AdminCenterPage.ParticipantTab} />)
                                        : (<Skeleton variant="rectangular" animation="wave" sx={{ paddingTop: "40%" }} height={0} />)

                                }
                            </Paper>
                        </motion.div>
                    </Grid>
                </Grid>
            ) : (
                <Box p={2} mt={2} alignItems="center" justifyContent="center" style={{ marginTop: '150px', padding: '40px' }}>
                    <Grid container direction="row" alignItems="center" justifyContent="center" spacing={2}>
                        <Grid item xs={12}>
                            <Skeleton variant="rectangular" animation="wave" sx={{ paddingTop: "20%" }} height={0} />
                        </Grid>
                        <Grid item xs={12}>
                            <Skeleton variant="rectangular" animation="wave" sx={{ paddingTop: "30%" }} height={0} />
                        </Grid>

                    </Grid>

                </Box>
            )}
            <Footer />
        </div>
    );


};

export default AdminCenterParticipants;

/*  <Paper elevation={16} style={{marginTop: '100px', padding:'40px'}}>
          <h3>
              HOME
            </h3>
            <Button onClick={logoutUser}>Logout</Button>
            <TermsAndConditions props={TCS.TsAndCsPage}/>
          </Paper> */